import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ResourceTabs = _resolveComponent("ResourceTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$fetchState.pending)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createVNode(_component_ResourceTabs, {
      mode: _ctx.mode,
      value: _ctx.value
    }, null, 8, ["mode", "value"])
  ], 64))
}